import React, { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Carousel from './components/Carousel';
import Hero from './components/Hero';
import DynamicHero from './components/DynamicHero';
import Services from './components/Services';
import Divisions from './components/Divisions';
import Industries from './components/Industries';
import Insights from './components/Insights';
import Partnership from './components/Partnership';
import Careers from './components/Careers';
import About from './components/About';
import Contact from './components/Contact';
import ShieldEx from './components/ShieldEx';
import Footer from './components/Footer';
import AIChatbot from './components/AIChatbot';
import AIParticles from './components/AIParticles';

function App() {
  const [activeSection, setActiveSection] = useState('home');
  const [showNotification, setShowNotification] = useState(false);

  const handleNotification = () => {
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 5000);
  };

  const handleSectionChange = (sectionId) => {
    setActiveSection(sectionId);
  };

  // Listen for section change events from child components
  React.useEffect(() => {
    const handleSectionChangeEvent = (e) => {
      // Scroll to top immediately before changing section
      window.scrollTo({ top: 0, behavior: 'instant' });
      setActiveSection(e.detail);
    };
    
    window.addEventListener('sectionChange', handleSectionChangeEvent);
    return () => {
      window.removeEventListener('sectionChange', handleSectionChangeEvent);
    };
  }, []);

  const renderSection = () => {
    switch (activeSection) {
      case 'home':
        return (
          <>
            <DynamicHero />
            <Hero />
          </>
        );
      case 'industries':
        return <Industries />;
      case 'insights':
        return <Insights />;
      case 'services':
        return <Services />;
      case 'divisions':
        return <Divisions />;
      case 'partnership':
        return <Partnership />;
      case 'careers':
        return <Careers />;
      case 'about':
        return <About />;
      case 'contact':
        return <Contact onFormSubmit={handleNotification} />;
      case 'shieldex':
        return <ShieldEx onSectionChange={handleSectionChange} />;
      default:
        return (
          <>
            <DynamicHero />
            <Hero />
          </>
        );
    }
  };

  return (
    <div className="App">
      <AIParticles />
      <Navbar onSectionChange={handleSectionChange} />
      {renderSection()}
      <Footer onSectionChange={handleSectionChange} />
      <AIChatbot />
      
      {showNotification && (
        <div className="notification notification-success">
          <div className="notification-content">
            <i className="fas fa-check-circle"></i>
            <span>Thank you for your message! We'll get back to you soon.</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;

